var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[_c('div',{staticStyle:{"height":"100%"}},[_c('SupportAdminTicketMessagesTable',{attrs:{"items":_vm.local_items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }